import React, { useEffect, useState } from "react";
import { Form, Input, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setWidgetLocationId,
  setWidgetName,
  selectWidgetName,
  selectWidgetLocationId,
} from "../../../redux/slices/chatbotBranding";
import LocationSelect from "../../commonComponents/LocationSelect";

const ChabotWidgetName = ({ onSuccess, onCancel, company, defaultLocationId = null }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const currentWidgetName = useSelector(selectWidgetName);
  const currentWidgetLocationId = useSelector(selectWidgetLocationId);

  // Load values from redux into the form when available
  useEffect(() => {
    form.setFieldsValue({
      widgetName: currentWidgetName || undefined,
      locationId: currentWidgetLocationId?.toString() || defaultLocationId?.toString() || undefined,
    });
  }, [form, currentWidgetName, currentWidgetLocationId, defaultLocationId]);

  const handleSave = async values => {
    // Store widget name and locationId in Redux
    dispatch(setWidgetName(values.widgetName));
    dispatch(setWidgetLocationId(values.locationId));

    // Trigger success callback
    if (onSuccess) {
      onSuccess(values.widgetName);
    }
  };

  const handleCancel = () => {
    // reset to current redux values
    form.resetFields();

    // Trigger cancel callback
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave} // Trigger handleSave only after successful validation
      >
        <Form.Item
          name="widgetName"
          label={<span className="form-field-label">Widget name</span>}
          rules={[{ required: true, message: "Widget name is required" }]}
        >
          <Input placeholder="Enter widget name" />
        </Form.Item>
        <Form.Item
          name="locationId"
          label={<span className="form-field-label">Location</span>}
          rules={[{ required: true, message: "Location is required" }]}
        >
          <LocationSelect variables={{ companyId: company?.id }} skip={!company?.id} />
        </Form.Item>
        <div className="flex mt-5 gap-2">
          <Button type="primary" htmlType="submit">
            Save
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </div>
      </Form>
    </div>
  );
};

export default ChabotWidgetName;
